import {
  ChakraBox,
  ChakraFlex,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

import { TaskCategoryColorMapper } from '~/lib/util/task.util';

const { paragraph } = EquipUITheme.typography;

type CategoryLabelProps = {
  categoryColor: string;
  categoryName: string;
};

const CategoryLabel = ({ categoryColor, categoryName }: CategoryLabelProps) => (
  <ChakraFlex align="center">
    <ChakraBox
      background={
        categoryColor ??
        TaskCategoryColorMapper[categoryName.replace(/ /g, '_').toLowerCase()]
      }
      borderRadius="50px"
      height="8px"
      marginLeft="6px"
      marginRight="22px"
      width="8px"
    />
    <ChakraText {...paragraph} color="black">
      {categoryName}
    </ChakraText>
  </ChakraFlex>
);

export default CategoryLabel;
